// extracted by mini-css-extract-plugin
export var headerCell = "_3z-1";
export var loadingSpinnerContainer = "_3z-4";
export var rowWrapper = "_3z-3";
export var standaloneTable = "_3z-5";
export var table = "_3z-0";
export var white = "_3z-2";